/* PRISKEL · sliders: one shared controller for every rail (arrows, progress line, drag on desktop),
   the homepage banner, quick add from moods / reviews / reels, and reduced-motion care. */
(function () {
  if (window.__pkSl) return; window.__pkSl = 1;
  var D = document;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover:hover) and (pointer:fine)');
  var ARROW = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d < 0 ? 'M19 12H5M11 6l-6 6 6 6' : 'M5 12h14M13 6l6 6-6 6') + '"/></svg>'; };
  function scrollableX(r) { var o = getComputedStyle(r).overflowX; return (o === 'auto' || o === 'scroll') && r.scrollWidth > r.clientWidth + 4; }


  /* ---------------- where each card sits when snapped, and a slow eased glide between them ---------------- */
  function snaps(r) {
    var rr = r.getBoundingClientRect(), cs = getComputedStyle(r), pad = parseFloat(cs.scrollPaddingLeft) || 0, bl = parseFloat(cs.borderLeftWidth) || 0, out = [];
    [].forEach.call(r.children, function (c) { if (!c.offsetWidth) return; out.push(Math.round(r.scrollLeft + c.getBoundingClientRect().left - rr.left - bl - pad)); });
    var max = r.scrollWidth - r.clientWidth;
    return out.map(function (x) { return Math.max(0, Math.min(x, max)); });
  }
  function nearest(xs, x) { var b = 0, d = 1e9; xs.forEach(function (v, i) { var dd = Math.abs(v - x); if (dd < d) { d = dd; b = i; } }); return b; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function glide(r, to) {
    cancelAnimationFrame(r.__pkRaf);
    var s = r.scrollLeft, d = to - s;
    if (Math.abs(d) < 1) return;
    if (REDUCE) { r.scrollLeft = to; return; }
    var dur = Math.min(950, Math.max(520, Math.abs(d) * .55)), t0 = performance.now();
    r.classList.add('is-glide'); r.__pkTo = to; r.__pkGl = 1;
    function f(now) {
      var p = Math.min(1, (now - t0) / dur);
      r.scrollLeft = s + d * ease(p);
      if (p < 1) r.__pkRaf = requestAnimationFrame(f);
      else { r.__pkGl = 0; r.classList.remove('is-glide'); }
    }
    r.__pkRaf = requestAnimationFrame(f);
  }
  function stopGlide(r) { if (!r.__pkGl) return; cancelAnimationFrame(r.__pkRaf); r.__pkGl = 0; r.classList.remove('is-glide'); }
  function page(r, dir) {
    var xs = snaps(r); if (!xs.length) return;
    var kids = [].filter.call(r.children, function (c) { return c.offsetWidth; });
    var stepw = xs.length > 1 ? Math.max(1, xs[1] - xs[0]) : r.clientWidth;
    var n = kids.length > 1 ? Math.max(1, Math.floor((r.clientWidth + (stepw - kids[0].offsetWidth)) / stepw)) : 1;
    var from = r.__pkGl ? r.__pkTo : r.scrollLeft, i = nearest(xs, from);
    var j = Math.max(0, Math.min(xs.length - 1, i + dir * n));
    var to = xs[j];
    if (dir > 0 && to <= from + 2) to = r.scrollWidth - r.clientWidth;
    glide(r, to);
  }

  /* ---------------- drag to scroll (mouse only), then settle on the nearest card ---------------- */
  function drag(r) {
    if (r.__pkDr) return; r.__pkDr = 1;
    var dn = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0;
    r.addEventListener('dragstart', function (e) { if (FINE.matches) e.preventDefault(); });
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { r.addEventListener(ev, function () { stopGlide(r); }, { passive: true }); });
    r.addEventListener('pointerdown', function (e) {
      if (!FINE.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('input,select,textarea,label,button,[data-pk-qa],video[controls]')) return;
      if (!scrollableX(r)) return;
      dn = true; moved = false; sx = lx = e.clientX; sl = r.scrollLeft; lt = performance.now(); v = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dn) return;
      var dx = e.clientX - sx;
      if (!moved) { if (Math.abs(dx) < 6) return; moved = true; r.classList.add('is-drag'); }
      e.preventDefault();
      r.scrollLeft = sl - dx;
      var now = performance.now(); v = (e.clientX - lx) / Math.max(1, now - lt); lx = e.clientX; lt = now;
    }, { passive: false });
    function end() {
      if (!dn) return; dn = false;
      if (!moved) return;
      r.__pkNoClick = Date.now();
      var xs = snaps(r), cw = xs.length > 1 ? Math.abs(xs[1] - xs[0]) : r.clientWidth, fl = Math.max(-cw, Math.min(cw, v * 240)), to = xs.length ? xs[nearest(xs, r.scrollLeft - fl)] : r.scrollLeft;
      r.classList.remove('is-drag');
      glide(r, to);
    }
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
    r.addEventListener('click', function (e) { if (r.__pkNoClick && Date.now() - r.__pkNoClick < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------------- arrows + a fine progress line under a rail ---------------- */
  function rail(r, mode) {
    if (r.__pkR) return; r.__pkR = 1;
    drag(r);
    [].forEach.call(r.querySelectorAll('img'), function (im) { im.decoding = 'async'; });
    if (mode === 'none' || mode === 'gallery') return;
    var bar = D.createElement('div');
    bar.className = 'pk-rc pk-rc--' + mode;
    bar.innerHTML = '<span class="pk-rc__bar" aria-hidden="true"><i></i></span><button type="button" class="pk-rc__btn" data-d="-1" aria-label="Previous">' + ARROW(-1) + '</button><button type="button" class="pk-rc__btn" data-d="1" aria-label="Next">' + ARROW(1) + '</button>';
    r.parentNode.insertBefore(bar, r.nextSibling);
    var thumb = bar.querySelector('i'), btns = bar.querySelectorAll('.pk-rc__btn'), raf = 0;
    function sync() {
      raf = 0;
      var ok = scrollableX(r);
      bar.classList.toggle('is-off', !ok);
      r.classList.toggle('pk-grab', ok && FINE.matches);
      if (!ok) return;
      var max = r.scrollWidth - r.clientWidth, w = Math.max(r.clientWidth / r.scrollWidth * 100, 12);
      thumb.style.width = w + '%';
      thumb.style.transform = 'translate3d(' + (max > 0 ? r.scrollLeft / max * (100 - w) / w * 100 : 0) + '%,0,0)';
      btns[0].disabled = r.scrollLeft < 4; btns[1].disabled = r.scrollLeft > max - 4;
    }
    r.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(sync); });
    sync(); setTimeout(sync, 900); window.addEventListener('load', sync);
  }
  var RAILS = [
    ['.lx-cat__rail', 'all'],
    ['.lx-mood__rail', 'mobile'],
    ['.pk-wr__rail', 'all'],
    ['.pk-vr__rail', 'all'],
    ['.pk-rv__track', 'arrows'],
    ['.pk-cl__rail', 'mobile'],
    ['.lv-rail', 'none'],
    ['.pk-s2__rail', 'none'],
    ['.pk-pd__track', 'gallery']
  ];
  function rails(root) { RAILS.forEach(function (c) { (root || D).querySelectorAll(c[0]).forEach(function (r) { rail(r, c[1]); }); }); }


  /* ---------------- every arrow on the site glides one page of whole cards ---------------- */
  var ARW = '.pk-rc__btn,[data-pkp-lprev],[data-pkp-lnext],[data-lx-prev],[data-lx-next]';
  function railFor(b) {
    if (b.classList.contains('pk-rc__btn')) return b.parentNode.previousElementSibling;
    var sec = b.closest('[data-pkp-look],[data-lx-mood],section');
    return sec && sec.querySelector('[data-pkp-lrail],[data-lx-rail]');
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(ARW);
    if (!b || b.disabled) return;
    var r = railFor(b); if (!r) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var dir = (b.matches('[data-pkp-lprev],[data-lx-prev]') || b.getAttribute('data-d') === '-1') ? -1 : 1;
    page(r, dir);
  }, true);

  /* ---------------- homepage banner: holds while you look, never rushes ---------------- */
  function hero(h) {
    if (h.__pkH) return; h.__pkH = 1;
    var slides = [].slice.call(h.querySelectorAll('[data-pk-slide]')), dots = [].slice.call(h.querySelectorAll('[data-pk-dot]'));
    if (slides.length < 2) return;
    /* 5 s a slide: long enough to read the line and see the piece, short enough that the second slide is seen */
    var dur = Math.min(Math.max(parseFloat(h.getAttribute('data-speed')) || 5, 3.5), 6) * 1000;
    h.style.setProperty('--pk-hero-dur', dur + 'ms');
    var i = 0, t = null, holds = {}, vis = true, tt = null;
    function held() { for (var k in holds) if (holds[k]) return true; return false; }
    function restartDot() { var d = dots[i], sp = d && d.querySelector('span'); if (sp) { sp.style.animation = 'none'; void sp.offsetWidth; sp.style.animation = ''; } }
    function go(n) {
      h.classList.add('hx-seen');
      slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true'); slides[i].setAttribute('inert', '');
      if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].setAttribute('aria-selected', 'false'); }
      i = (n + slides.length) % slides.length;
      var s = slides[i];
      s.classList.add('is-on'); s.removeAttribute('aria-hidden'); s.removeAttribute('inert');
      [].forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
      if (dots[i]) { dots[i].classList.add('is-on'); dots[i].setAttribute('aria-selected', 'true'); restartDot(); }
      schedule();
    }
    function schedule() { clearTimeout(t); if (held() || !vis) return; t = setTimeout(function () { go(i + 1); }, dur); }
    function hold(k, on) {
      var was = held(); holds[k] = on; var now = held();
      h.classList.toggle('is-paused', now);
      if (now) clearTimeout(t); else if (was) { restartDot(); schedule(); }
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    h.addEventListener('mouseover', function (e) { if (FINE.matches && e.target.closest('a,button')) hold('hover', true); });
    h.addEventListener('mouseout', function (e) { var a = e.target.closest('a,button'); if (a && !(e.relatedTarget && a.contains(e.relatedTarget))) hold('hover', false); });
    h.addEventListener('mouseleave', function () { hold('hover', false); });
    h.addEventListener('focusin', function (e) { try { if (e.target.matches(':focus-visible')) hold('focus', true); } catch (_) {} });
    h.addEventListener('focusout', function (e) { if (!h.contains(e.relatedTarget)) hold('focus', false); });
    h.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(i + 1); else if (e.key === 'ArrowLeft') go(i - 1); });
    D.addEventListener('visibilitychange', function () { hold('tab', D.hidden); });
    var x0 = null, y0 = null;
    h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; clearTimeout(tt); hold('touch', true); }, { passive: true });
    h.addEventListener('touchend', function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1)); }
      x0 = null; clearTimeout(tt); tt = setTimeout(function () { hold('touch', false); }, 2500);
    }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) schedule(); else clearTimeout(t); }, { threshold: .25 }).observe(h);
    schedule();
  }

  /* ---------------- quick add (moods, reviews, reels) ---------------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pk-qa]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled) return; b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-pk-qa'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; })
      .catch(function () { var u = b.getAttribute('data-url'); if (u) location.href = u; })
      .then(function () { setTimeout(function () { b.disabled = false; }, 2400); });
  }, true);

  /* ---------------- mood index: a hover only highlights, it never moves the rail ---------------- */
  function moods() {
    D.querySelectorAll('[data-lx-mood]').forEach(function (sec) {
      if (sec.__pkMd) return; sec.__pkMd = 1;
      sec.addEventListener('mouseenter', function (e) { if (e.target.matches && e.target.matches('[data-lx-mood-go]')) e.stopPropagation(); }, true);
    });
  }

  /* ---------------- reviews: the carousel rests while it is off screen ---------------- */
  function reviews() {
    if (!('IntersectionObserver' in window)) return;
    D.querySelectorAll('[data-pk-reviews]').forEach(function (sec) {
      if (sec.__pkRv) return; sec.__pkRv = 1;
      new IntersectionObserver(function (es) {
        var on = es[0].isIntersecting;
        if (!on) sec.dispatchEvent(new Event('mouseenter'));
        else if (!sec.matches(':hover')) sec.dispatchEvent(new Event('mouseleave'));
      }, { threshold: .2 }).observe(sec);
    });
  }

  /* ---------------- reduced motion: reels and gallery videos wait for a tap ---------------- */
  function still() {
    if (!REDUCE) return;
    D.querySelectorAll('[data-pk-autoplay]').forEach(function (t) { t.setAttribute('data-pk-held', '1'); var v = t.querySelector('video'); if (v && !v.paused) v.pause(); });
    D.querySelectorAll('.pk-pd__track video').forEach(function (v) { v.removeAttribute('autoplay'); v.autoplay = false; v.pause(); v.controls = true; });
  }

  function boot(root) {
    rails(root);
    (root || D).querySelectorAll('[data-pk-hero2]').forEach(hero);
    moods(); reviews(); still();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  D.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
